import { useTranslation } from "react-i18next";

import {
  SponsorImage,
  SponsorImagesSliderProps,
} from "@models/components/kiosk.model";

const SponsorImagesSlider = ({ sponsorImages }: SponsorImagesSliderProps) => {
  const { t } = useTranslation();

  const displayImages = sponsorImages.slice(0, 6);

  const renderCard = (sponsor: SponsorImage, index: number) => (
    <div
      key={`${sponsor.logo}-${index}`}
      className="screensaver-sponsor-card touch-card"
      data-testid={`sponsor-card-${index}`}
    >
      <img
        src={sponsor.logo}
        alt={`Sponsor ${index + 1}`}
        className="screensaver-sponsor-image transition-all"
      />
    </div>
  );

  return (
    <div className="sponsor-grid-wrapper" data-testid="sponsor-slider-wrapper">
      <div className="screensaver-sponsors-title text-center text-muted text-uppercase fw-bold tracking-widest">
        {t("kiosk.screensaver.ourSponsors")}
      </div>
      <div className="screensaver-sponsors-grid-display">
        <div className="sponsors-image-grid" data-testid="sponsors-image-grid">
          {displayImages.map((sponsor, index) => renderCard(sponsor, index))}
        </div>
      </div>
    </div>
  );
};

export default SponsorImagesSlider;
